import { bindable, bindingMode, containerless } from 'aurelia-framework';
import { OrgStructureNode } from '../../../models/org-structure-node';

@containerless()
export class OrgNode {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) sourceComponent: any;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) item: any;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) currentItemId: number;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) removeNodeFn: (item: OrgStructureNode, which: "self" | "children") => Promise<any>;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) addNodeFn: (item: OrgStructureNode, which: "parent" | "child") => Promise<any>;

    addNode(item: OrgStructureNode, which: "parent" | "child") {
        this.addNodeFn(item, which);
    }

    removeNode(item: OrgStructureNode, which: "self" | "children") {
        this.removeNodeFn(item, which);
    }
}

